/**
 * Browser bundles can only receive REACT_APP_* variables. The build script
 * derives this value from ENABLE_OPERATIONAL_CONTROL, which remains the
 * deployment-level source of truth.
 */
export const isOperationalControlFeatureEnabled = () =>
  process.env.REACT_APP_ENABLE_OPERATIONAL_CONTROL === "true";
